import React from 'react'
import Box from '@mui/material/Box'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

import { styled } from '@mui/material/styles'
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector'

import { StepIconProps } from '@mui/material'
import Check from '@mui/icons-material/Check'

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 15,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: theme.palette.primary.main,
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.borderColor,
    borderTopWidth: 3,
    borderRadius: 1,
  },
}))

const QontoStepIconRoot = styled('div')<{
  ownerState: { active?: boolean; completed?: boolean }
}>(({ theme, ownerState }) => ({
  color: theme.palette.common.black,
  display: 'flex',
  height: 22,
  width: 22,
  padding: 5,
  borderWidth: '2px',
  borderStyle: 'solid',
  borderRadius: '50%',
  borderColor: theme.palette.borderColor,
  aspectRatio: 1,
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Mont-semibold',
  fontSize: 20,
  ...(ownerState.active && {
    color: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  }),
  ...(ownerState.completed && {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
  }),
  '& .QontoStepIcon-completedIcon': {
    color: theme.palette.common.white,
    zIndex: 1,
    fontSize: 26,
  },
}))

function QontoStepIcon(props: StepIconProps & { index: number }) {
  const { active, completed, className, index } = props

  return (
    <QontoStepIconRoot
      ownerState={{ active, completed }}
      className={className}
    >
      {completed ? (
        <Check className='QontoStepIcon-completedIcon' />
      ) : (
        <div>{index + 1}</div>
      )}
    </QontoStepIconRoot>
  )
}

type SparkStepperProps = {
  stepIDs: number[]
  activeStep: number
}

function SparkStepper({ stepIDs, activeStep }: SparkStepperProps) {
  return (
    <Box sx={{ width: '100%' }}>
      <Stepper
        activeStep={activeStep - 1}
        connector={<QontoConnector />}
      >
        {stepIDs.map((stepID, index) => {
          return (
            <Step
              key={stepID}
              sx={{ padding: 0 }}
            >
              <StepLabel
                sx={{ span: { padding: 0 } }}
                StepIconComponent={(props) => (
                  <QontoStepIcon
                    {...props}
                    index={index}
                  />
                )}
              />
            </Step>
          )
        })}
      </Stepper>
    </Box>
  )
}

export default SparkStepper
